import { effect, inject, Injectable } from '@angular/core';
import { patchState, signalState } from '@ngrx/signals';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { IUiError } from '../model';

interface ErrorState { error: IUiError | undefined }
const initialState: ErrorState = { error: undefined };

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  readonly #translation = inject(TranslateService);
  readonly #skipTranslation = ['RUNTIME_ERROR', 'UNAUTHORIZED'];
  readonly #messageService = inject(MessageService);
  readonly #state = signalState(initialState);

  constructor() {
    effect(() => {
      const error = this.#state.error();
      if (error) {
        if (this.#skipTranslation.includes(error.code)) {
          return;
        }
        this.#messageService.add({
          severity: 'error',
          summary: this.#translation.instant('error'),
          detail: error.status === 0
            ? this.#translation.instant('httpError.SERVER_ERROR')
            : this.#translation.instant(`httpError.${error.code}`, error.params ? { ...error.params } : { msg: error.message }) || error.code,
        });
      }
    });
  }

  setError(error: IUiError) {
    patchState(this.#state, { error: error });
  }
}
